import "fancybox/dist/js/jquery.fancybox.js"
import "foundation-sites"
import "slick-carousel"
import "inputmask/dist/jquery.inputmask.min.js"
import "suggestions-jquery/dist/js/jquery.suggestions.js"

import "./handleMap.js"
import "./handleFuel"
import "./customEqualizer"
import "./customSelect"
import "./go-top"
import "./replaceImgSvg"
import "./bill"
import "./fort"
import "./fit"
import "./switch"
import "./handleInputNumber"
import "./navigation"
import "./searchForm"


import "../scss/style.scss"

;(function($) {
  "use strict"
  $(document).foundation()


  $(document).on('click','.reveal__close', function() {

    $('.reveal-overlay').trigger('click')
  });
  // functions
  function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
  }
  function qs(str) {
    return document.querySelector(str)
  }
  function roundIt(number, precision) {
    var factor = Math.pow(10, 0 | precision)
    var tempNumber = number * factor
    var roundedTempNumber = Math.round(tempNumber)
    return roundedTempNumber / factor
  }
  function debounce(func, wait, immediate) {
    var timeout
    return function() {
      var context = this,
        args = arguments
      var later = function() {
        timeout = null
        if (!immediate) func.apply(context, args)
      }
      var callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
      if (callNow) func.apply(context, args)
    }
  }

  function calc(e) {
    var CalcForm = document.forms["Calculator"]
    var b6 = 0.003,
      b7 = 0.002,
      b8 = 0.001

    var f6 = parseFloat(Math.max(0, CalcForm.d6.value))
    CalcForm.d6.value = f6
    qs("#f6").textContent = f6

    var f7 = f6 * parseFloat(Math.max(0, CalcForm.d7.value))
    CalcForm.d7.value = f7 / f6
    qs("#f7").textContent = f7

    var f8 = f7 * parseFloat(Math.max(0, CalcForm.d8.value))
    CalcForm.d8.value = f8 / f7
    qs("#f8").textContent = f8

    var i5 = parseFloat(Math.max(1, CalcForm.h5.value))
    CalcForm.h5.value = i5

    var i6 = f6 * parseFloat(Math.max(0, CalcForm.h6.value))
    CalcForm.h6.value = i6 / f6

    var i7 = f7 * parseFloat(Math.max(0, CalcForm.h7.value))
    CalcForm.h7.value = i7 / f7

    var i8 = f8 * parseFloat(Math.max(0, CalcForm.h8.value))
    CalcForm.h8.value = i8 / f8
    //CalcForm.h8.value = parseFloat(Math.max(0, CalcForm.h8.value));

    var j6 = i6 * b6
    qs("#j6").textContent = j6

    var j7 = i7 * b7
    qs("#j7").textContent = j7

    var j8 = i8 * b8
    qs("#j8").textContent = roundIt(j8, 1)

    // сумма накопленная
    var j5 = j6 + j7 + j8
    qs("#j9").textContent = j5

    var k5 = Math.floor((j5 / i5) * 100000) / 1000
    // не больше 30 %
    k5 = k5 > 30 ? 30 : k5
    qs("#k5").textContent = roundIt(k5, 2) + " %"

    // сумма к начислению
    var j10 = roundIt(i5 * (k5 / 100), 0)
    j10 = j10 > j5 ? j5 : j10
    qs("#j10").textContent = j10

    e && e.preventDefault()
  }

  var lastWidth = $(window).width()
  function equalHeight() {
    var $tabs = $('.tabs a[id$="tab-label"]')
    var widthDiff = $(window).width() - lastWidth
    lastWidth = $(window).width()

    var heights = $tabs.toArray().map(function(el) {
      return $(el).outerHeight()
    })

    // if widthDiff < 0 ширина окна уменьшается
    var targetHeight = heights.reduce(function(f, s) {
      if (widthDiff < 0) return f >= s ? f : s
      // берем наивысший
      else return f < s ? f : s
    })

    $tabs.each(function(i, el) {
      var elh = $(el).outerHeight()
      var diff = targetHeight - elh

      if (diff) {
        var pad = parseInt($(el).css("padding-top")) + diff / 2
        $(el).css({ paddingTop: pad, paddingBottom: pad })
      }
    })
  }

  function sendFormCaptcha(el) {
    var $this = $(el)
    var $form = $("form[name=" + $this.data("form-name") + "]")
    $form.find("input[name=captcha_word]").val(
      $this
        .parents(".x-captcha-form")
        .find("input[name=captcha_word]")
        .val()
    )
    $form
      .find("[type=button]")
      .prop("type", "submit")
      .trigger("click")
    $form.submit()
  }
  // DOM ready

  if (window.matchMedia('(max-width: 767px)').matches) {
    $(".advant-carousel").slick({
      infinite: false,
      arrows: false,
      dots: false,
      variableWidth: true,
      slidesToScroll: 1,
    });
  }

  $(".x-carousel-main").slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesPerRow: 1,
    slidesToShow: 1,
    slidesToScroll: 0,
    autoplay: false,
    autoplaySpeed: 5000,
    autoplayHoverPause: true,
    fade: true,
    swipeToSlide: false,
    prevArrow:
      '<span class="show-for-xlarge slick-prev carousel-main__prev"><img src="/local/templates/pc_common/images/slick-arrow.svg"/></span>',
    nextArrow:
      '<span class="show-for-xlarge slick-next carousel-main__next"><img src="/local/templates/pc_common/images/slick-arrow.svg"/></span>'
  })
  $(".content__fall").slick({
    infinite: false,
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    autoplayHoverPause: true,
    fade: false,
    prevArrow:
      '<span class="slick-prev"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="25" transform="matrix(1.19249e-08 1 1 -1.19249e-08 25 25)" fill="white"/><path d="M22.5 17L31.25 25.75L22.5 34.5" stroke="#BF0D0D" stroke-width="3" stroke-linecap="round"/></svg></span>',
    nextArrow:
      '<span class="slick-next"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="25" transform="matrix(1.19249e-08 1 1 -1.19249e-08 25 25)" fill="white"/><path d="M22.5 17L31.25 25.75L22.5 34.5" stroke="#BF0D0D" stroke-width="3" stroke-linecap="round"/></svg></span>',
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: 3} },
      { breakpoint: 1000, settings: { slidesToShow: 2} },
      { breakpoint: 640, settings: { variableWidth:true} }
    ]
  })
  $(".content__fake").slick({
    infinite: true,
    dots: false,
    arrows: true,
  variableWidth:true,
    slidesToScroll: 1,
    autoplay: false,
    centerMode:true,
    autoplaySpeed: 5000,
    autoplayHoverPause: true,
    fade: false,
    prevArrow:
      '<span class="slick-prev"><svg width="25" height="44" viewBox="0 0 25 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 42L22 22L2 2" stroke="#4F4F4F" stroke-width="3" stroke-linecap="round"/></svg></span>',
    nextArrow:
      '<span class="slick-next"><svg width="25" height="44" viewBox="0 0 25 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 42L22 22L2 2" stroke="#4F4F4F" stroke-width="3" stroke-linecap="round"/></svg></span>',

  })

  $("a.thumbnail").fancybox()

  /**
   * Калькулятор - формула и изменение значения ползунка
   */
  if ($('form[name="Calculator"]').length) {
    var CalcForm = document.forms["Calculator"]
    CalcForm.addEventListener("submit", calc)
    $('form[name="Calculator"] input.calc__input').on("change", calc)

    // ползунок калькулятора
    var slider_output = qs("#slider-output")

    $(".slider").on("changed.zf.slider", function(e, obj) {
      var slider_handle = obj[0]
      if (slider_handle.className == "slider-handle") {
        var val = formatNumber(slider_output.value)
        slider_handle.setAttribute("data-val", val)
      }
      calc()
    })
  }

  /**
   * Пагинация на мобильном
   */
  if ($(window).width() < 640 && $("#delete-me-mobile").length) {
    $("#delete-me-mobile").remove()
  }

  /**
   * Большие таблицы  на планшетах - скролл
   */
  if ($(window).width() < 960 && $("table:not(.calc)").length) {
    $("table:not(.calc)").addClass("scroll")
  }

  /**
   * Уравнивание вкладок продуктов на планшетах
   */
  if (Foundation.MediaQuery.is("medium") && $('.tabs a[id$="tab-label"]').length) {
    var $tabs = $('.tabs a[id$="tab-label"]')
    var heights = $tabs.toArray().map(function(el) {
      return $(el).outerHeight()
    })
    var maxH = heights.reduce(function(f, s) {
      return f >= s ? f : s
    })

    $tabs.each(function(i, el) {
      var elh = $(el).outerHeight()
      var diff = maxH - elh
      if (diff) {
        var pad = parseInt($(el).css("padding-top")) + diff / 2
        $(el).css({ paddingTop: pad, paddingBottom: pad })
      }
    })
  }

  /**
   * Автоподстановка адресов
   */
  window.personal = window.personal || {}
  window.personal.addressSuggestions = function($input) {
    $input.suggestions({
      serviceUrl: "https://suggestions.dadata.ru/suggestions/api/4_1/rs",
      token: "a873f25f035b86913ab7c13885cae9c74cbf3b75",
      type: "ADDRESS",
      count: 4,
      geoLocation: false,
      onSelect: function() {}
    })
  }
  $(".x-kladr-address").length && window.personal.addressSuggestions($(".x-kladr-address"))
})(jQuery)
